<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <label class="label" for="vehiculo">Instalación</label>
      <div class="card">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label class="label" for="instalador">Instalador</label>
                <SelectInstalador v-model="instalador" />
              </div>
              <SelectAditivos />
              <EmularSensorDeContacto />
              <SelectSensorIN2 />
              <SensorDeMovimiento />
              <div
                class="col-12 col-md-6 form-group form-group-sm d-flex align-items-center"
              >
                <input
                  id="instalacionEnTaller"
                  v-model="instalacionEnTaller"
                  class="form-check-inline"
                  type="checkbox"
                  style="zoom: 2; cursor: pointer"
                />
                <label
                  class="label"
                  for="instalacionEnTaller"
                  style="cursor: pointer"
                >
                  Instalación en taller
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="ubicacionAvl">Ubicación AVL</label>
                <textarea
                  id="ubicacionAvl"
                  v-model="ubicacionAvl"
                  :class="`form-control form-control-sm text-center bg-white`"
                  style="cursor: text"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInstalador from "@/pages/Clientes/Contratos/Commons/SelectInstalador";
import SelectAditivos from "@/pages/Clientes/Contratos/Crear/Instalacion/SelectAditivos";
import EmularSensorDeContacto from "@/pages/Clientes/Contratos/Crear/Instalacion/EmularSensorDeContacto";
import SelectSensorIN2 from "@/pages/Clientes/Contratos/Crear/Instalacion/SelectSensorIN2";
import SensorDeMovimiento from "@/pages/Clientes/Contratos/Crear/Instalacion/SensorDeMovimiento";

export default {
  name: "InstalacionForm",
  components: {
    SelectInstalador,
    SelectAditivos,
    EmularSensorDeContacto,
    SelectSensorIN2,
    SensorDeMovimiento,
  },
  computed: {
    ubicacionAvl: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.ubicacionAvl;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setUbicacionAvl", val);
      },
    },
    instalador: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.instalador;
      },
      set(val) {
        this.$store.commit("Contratos/NuevoContrato/setInstalador", val);
      },
    },
    instalacionEnTaller: {
      get() {
        return !!this.$store.state.Contratos.NuevoContrato.instalacionEnTaller;
      },
      set(val) {
        this.$store.commit(
          "Contratos/NuevoContrato/setInstalacionEnTaller",
          val ? 1 : 0,
        );
      },
    },
  },
};
</script>

<style scoped></style>
